/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import ToggleSlider from './ToggleSlider.tsx'
import { SettingsMenuProps } from './utils/types.ts'

export default function SettingsMenu({
    showWinner,
    setShowWinner,
    showValues,
    setShowValues,
    showTitle,
    setShowTitle,
    showTeams,
    setShowTeams,
    title,
    setTitle,
    handleDownload,
    disableToggleTitle,
}: SettingsMenuProps) {
    return (
        <div
            {...({
                popover: 'auto',
            } as React.HTMLAttributes<HTMLDivElement>)}
            id="settings-popover"
            className="comp-tool-popover"
            style={{
                backgroundColor: '#ffffff',
                color: '#111111',
                border: '4px solid #333333',
                padding: '1.5rem',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
                width: '280px',
                height: '350px',
                boxSizing: 'border-box',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0.5rem',
                }}
            >
                <h3 style={{ margin: 0 }}>Settings</h3>
                <button
                    type="button"
                    onClick={() => {
                        const popover =
                            document.getElementById('settings-popover')
                        if (popover && 'hidePopover' in popover) {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            ;(popover as any).hidePopover()
                        }
                    }}
                    className="modal-close-button"
                    aria-label="Close Settings"
                >
                    &times;
                </button>
            </div>
            <hr
                style={{
                    borderTop: '1px solid #555555',
                    marginBottom: '1rem',
                    marginTop: '0',
                }}
            />

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                }}
            >
                <ToggleSlider
                    name="Highlight Winner"
                    type="winner"
                    val={showWinner}
                    onClick={setShowWinner}
                />
                <ToggleSlider
                    name="Show Values"
                    type="values"
                    val={showValues}
                    onClick={setShowValues}
                />
                <ToggleSlider
                    name="Show Teams"
                    type="teams"
                    val={showTeams}
                    onClick={setShowTeams}
                />
                <ToggleSlider
                    name="Add Title"
                    type="title"
                    val={showTitle}
                    onClick={setShowTitle}
                    disabled={disableToggleTitle}
                />
                {!showTitle && disableToggleTitle && (
                    <div style={{ fontSize: '11px', color: 'red' }}>
                        <text>
                            Too many stats selected to add title; remove some to
                            make room.
                        </text>
                    </div>
                )}

                {showTitle && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.2rem',
                            marginBottom: '0.5rem',
                        }}
                    >
                        <input
                            id="custom-title-input"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter chart title..."
                            maxLength={50}
                            style={{
                                padding: '0.4rem',
                                border: '1px solid #cccccc',
                                borderRadius: '4px',
                                fontSize: '0.9rem',
                                fontFamily: 'inherit',
                            }}
                        />
                    </div>
                )}

                <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => {
                        const popover =
                            document.getElementById('settings-popover')
                        if (popover && 'hidePopover' in popover) {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            ;(popover as any).hidePopover()
                        }

                        handleDownload()
                    }}
                    style={{
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        marginBottom: '0px',
                    }}
                >
                    Download Image (Square)
                </button>
                <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => {
                        const popover =
                            document.getElementById('settings-popover')
                        if (popover && 'hidePopover' in popover) {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            ;(popover as any).hidePopover()
                        }
                        handleDownload(true)
                    }}
                    style={{
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        marginTop: '0px',
                    }}
                >
                    Download Image (16 x 9)
                </button>
            </div>
        </div>
    )
}
